import { Card, Form, Button, Input, Select, Checkbox } from "antd";
import React from "react";

function ApproveDisapproveComponent({
	handleStatus,
	loading,
	setStatus,
	parallel,
	parallelUsers,
	setAssignedUserId,
	dataRecord,
	setSpecificReturnGroupId,
}) {
	const approvedApproverGroups =
		dataRecord?.approvers?.filter((group) =>
			group.users?.every((user) => user.status === "Approved")
		) || [];

	const [form] = Form.useForm();
	const [parallelForm] = Form.useForm();

	// 🔁 Reusable Return to Group fields
	const ReturnToGroupFields = ({ formInstance }) => (
		<>
			<Form.Item name='return_to_group' valuePropName='checked'>
				<Checkbox
					onChange={(e) => {
						if (!e.target.checked) {
							formInstance.setFieldsValue({ approver_id: undefined });
						}
					}}
				>
					Return to specific group
				</Checkbox>
			</Form.Item>

			<Form.Item noStyle shouldUpdate>
				{() =>
					formInstance.getFieldValue("return_to_group") && (
						<Form.Item
							name='approver_id'
							rules={[{ required: true, message: "Select Approver Group" }]}
						>
							<Select placeholder='Select Approver Group'>
								{approvedApproverGroups.map((group) => (
									<Select.Option key={group.id} value={group.id}>
										{group.name}
									</Select.Option>
								))}
							</Select>
						</Form.Item>
					)
				}
			</Form.Item>
		</>
	);

	const applyReturnGroup = (formInstance) => {
		const returnToGroup = formInstance.getFieldValue("return_to_group");
		const approverId = formInstance.getFieldValue("approver_id");

		if (returnToGroup && approverId) {
			setSpecificReturnGroupId?.(approverId);
		} else {
			setSpecificReturnGroupId?.(null);
		}
	};

	const handleSubmit = (status) => {
		if (status === "Disapproved") {
			if (
				!window.confirm(
					"Are you sure you want to Disapprove this form? You will not be able to edit it again."
				)
			)
				return;
		}

		applyReturnGroup(form);
		setStatus(status);
		form.submit();
	};

	const handleParallelSubmit = (status) => {
		applyReturnGroup(parallelForm);

		parallelForm.validateFields().then((values) => {
			setAssignedUserId(values.assigned_user_id);
			setStatus(status);
			parallelForm.submit();
		});
	};

	return (
		<Card className='mb-4'>
			{/* ===== NORMAL FORM ===== */}
			{!parallel && (
				<Form
					form={form}
					onFinish={(values) =>
						handleStatus({ ...values, status: form.getFieldValue("status") })
					}
				>
					<Form.Item name='message'>
						<Input.TextArea placeholder='Type Reason' rows={2} />
					</Form.Item>

					<ReturnToGroupFields formInstance={form} />

					<Form.Item>
						<Button
							type='primary'
							className='mr-4 mb-4'
							onClick={() => handleSubmit("Approved")}
							loading={loading}
						>
							Approve
						</Button>
						<Button
							className='mr-4 mb-4'
							onClick={() => handleSubmit("Disapproved")}
							loading={loading}
						>
							Disapprove
						</Button>
						<Button
							className='mr-4 mb-4'
							onClick={() => handleSubmit("Return")}
							loading={loading}
						>
							Return
						</Button>
					</Form.Item>
				</Form>
			)}

			{/* ===== PARALLEL FORM ===== */}
			{parallel && (
				<Form
					form={parallelForm}
					initialValues={{
						assigned_user_id:
							parallelUsers.length > 0 ? parallelUsers[0].id : undefined,
					}}
					onFinish={(values) =>
						handleStatus({
							...values,
							status: parallelForm.getFieldValue("status"),
						})
					}
				>
					<Form.Item
						name='assigned_user_id'
						rules={[
							{ required: true, message: "Please select the Parallel User" },
						]}
					>
						<Select placeholder='Select Parallel User' size='large'>
							{parallelUsers.map((user) => (
								<Select.Option key={user.id} value={user.id}>
									{user.name}
								</Select.Option>
							))}
						</Select>
					</Form.Item>

					<Form.Item name='message'>
						<Input.TextArea placeholder='Type Reason' rows={2} />
					</Form.Item>

					<ReturnToGroupFields formInstance={parallelForm} />

					<Form.Item>
						<Button
							type='primary'
							className='mr-4 mb-4'
							onClick={() => handleParallelSubmit("Approved")}
							loading={loading}
						>
							Approve
						</Button>
						<Button
							className='mr-4 mb-4'
							onClick={() => handleParallelSubmit("Disapproved")}
							loading={loading}
						>
							Disapprove
						</Button>
						<Button
							className='mr-4 mb-4'
							onClick={() => handleParallelSubmit("Return")}
							loading={loading}
						>
							Return
						</Button>
					</Form.Item>
				</Form>
			)}
		</Card>
	);
}

export default ApproveDisapproveComponent;